import { defineStore } from 'pinia'
import ProductService from "@/services/product.service";
export const useProductStore = defineStore('product', {
    state: () => {
        return {
            products: [],
            productByIds: [],
            product: {},
            paginate: {},
            lastPage: 1,
        }
    },
    persist: true,
    actions: {
        async getListProducts(url, params) {
            try {
                const res = await ProductService.getListProducts(url, params)
                this.products = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return null
            }
        },
        async createOrUpdateProduct(url, params) {
            try {
                const res = await ProductService.createOrUpdateProduct(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async getListProductsByIds(url, params) {
            try {
                const res = await ProductService.getListProducts(url, params)
                this.productByIds = res.data
            } catch (e) {
                return null
            }
        },
        async getProductDetail(url, params) {
            try {
                const res = await ProductService.getListProducts(url, params)
                this.product = res.data
            } catch (e) {
                return null
            }
        },
        async delete(url, params) {
            try {
                const res = await ProductService.deleteProduct(url, params)
                return res.data
            } catch (e) {
                return null
            }
        }
    }
})
